import React from 'react';
import type { PcoPerson, PcoSettings } from './types';

interface PeopleProps {
  data: PcoPerson[];
  settings?: PcoSettings;
}

const People: React.FC<PeopleProps> = ({ data, settings = {} }) => {
  if (!data || data.length === 0) {
    return <div className="pco-empty"><p>No team members to display at this time.</p></div>;
  }

  const layout = settings['pco-layout'] || 'grid';
  const membershipType = settings['pco-membership-type'] || 'all';

  let filtered = data;
  if (membershipType && membershipType !== 'all') {
    filtered = filtered.filter((p) => p.membership === membershipType);
  }

  if (!filtered.length) {
    return <div className="pco-empty"><p>No team members to display.</p></div>;
  }

  if (layout === 'list') {
    return (
      <div className="pco-people-list">
        {filtered.map((person) => (
          <div className="pco-person-list-item" key={person.id}>
            <img className="pco-person-avatar" src={person.avatar} alt={person.name} loading="lazy" />
            <div>
              <h3>{person.name}</h3>
              {person.title && <div className="pco-person-title">{person.title}</div>}
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Grid (default)
  return (
    <div className="pco-people-grid">
      {filtered.map((person) => (
        <div className="pco-person-card" key={person.id}>
          <img className="pco-person-avatar" src={person.avatar} alt={person.name} loading="lazy" />
          <h3>{person.name}</h3>
          {person.title && <div className="pco-person-title">{person.title}</div>}
        </div>
      ))}
    </div>
  );
};

export default People;
